import { Route, Routes } from "react-router-dom";

import Transactions from "pages/Dashboard/Marchants";
import Shoppers from "pages/Dashboard/Shoppers";
import MerchantsList from "pages/Dashboard/Marchants/features/MerchantsList";
import ShoppersList from "pages/Dashboard/Shoppers/features/MerchantsList";
import MerchantProfile from "pages/Dashboard/Marchants/features/MerchantProfile";
import ShoppersProfile from "pages/Dashboard/Shoppers/features/MerchantProfile";
import SignIn from "pages/OnBoarding/SignIn";
import ComplianceList from "pages/Dashboard/Compliance/features/ComplianceList";
import Compliance from "pages/Dashboard/Compliance";
import AccountHolderForm from "pages/Dashboard/Compliance/features/AccountHolderForm";
import BusinessAccountForm from "pages/Dashboard/Compliance/features/BusinessAccountForm";
import BankVerificationForm from "pages/Dashboard/Compliance/features/BankVerificationForm";
import { ProtectedRoute } from "components/ProtectedRoute";
import Analytics from "pages/Dashboard/Analytics";
import WidgetAnalyticsList from "pages/Dashboard/Analytics/features/WidgetAnalyticsList";
import Reference from "pages/Dashboard/Reference";
import Crypto from "pages/Dashboard/Crypto";
import TransactionDetails from "pages/Dashboard/Transactions/features/ModalScreens/TransactionDetailsModal/TransactionDetails";
import TransactionsList from "pages/Dashboard/Reference/features/TransactionsList";
import CryptoTransactionsList from "pages/Dashboard/Crypto/features/TransactionsList";

const Router = () => {
  return (
    <>
      <Routes>
        {/* merchants */}
        <Route
          path="/dashboard/merchants"
          element={
            <ProtectedRoute path="">
              <Transactions />
            </ProtectedRoute>
          }
        >
          <Route path="" element={<MerchantsList />} />
          <Route path=":tribe_account_id" element={<MerchantProfile />} />
        </Route>
        {/* end merchants */}
        <Route
          path="/dashboard/shoppers"
          element={
            <ProtectedRoute path="">
              <Shoppers />
            </ProtectedRoute>
          }
        >
          <Route path="" element={<ShoppersList />} />
          <Route path=":tribe_account_id" element={<ShoppersProfile />} />
        </Route>

        {/* compliance */}
        <Route
          path="/dashboard/compliance/:tribe_account_id"
          element={
            <ProtectedRoute path="">
              <Compliance />
            </ProtectedRoute>
          }
        >
          <Route path="" element={<ComplianceList />} />
          <Route path="holder" element={<AccountHolderForm />} />
          <Route path="business" element={<BusinessAccountForm />} />
          <Route path="bvn" element={<BankVerificationForm />} />
        </Route>
        {/* end compliance */}
        {/* analytics */}
        <Route
          path="/dashboard/analytics"
          element={
            <ProtectedRoute path="">
              <Analytics />
            </ProtectedRoute>
          }
        >
          <Route path="" element={<WidgetAnalyticsList />} />
          {/* <Route path=":tribe_account_id" element={<MerchantProfile />} /> */}
        </Route>
        {/* end analytics */}

        {/* reference */}
        <Route
          path="/dashboard/reference"
          element={
            <ProtectedRoute path="">
              <Reference />
            </ProtectedRoute>
          }
        >
          <Route path="" element={<TransactionsList />} />
          <Route path=":tx_keyword" element={<TransactionDetails />} />
          {/* <Route path=":tribe_account_id" element={<MerchantProfile />} /> */}
        </Route>
        {/* end reference */}

        {/* Crypto Transactions */}
        <Route
          path="/dashboard/crypto"
          element={
            <ProtectedRoute path="">
              <Crypto />
            </ProtectedRoute>
          }
        >
          <Route path="" element={<CryptoTransactionsList />} />
          <Route path=":tx_keyword" element={<TransactionDetails />} />
        </Route>
        {/* end crypto */}

        <Route
          path="/"
          element={
            <ProtectedRoute path="/" notProtected>
              <SignIn />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
};

export default Router;
